import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '@libs/components/icons';
import { ProductBaseModel, ProductLabelGroup, ProductLabelModel, ProductPricesModel } from '@libs/shop/models';
import { LuxonDatePipe } from '@libs/shared/ui';
import { ProductBundleMaxOrderCountLabelComponent } from './product-bundle-max-order-count-label';
import { ProductBundleValidToLabelComponent } from './product-bundle-valid-to-label';

@Component({
  selector: 'ui-product-labels',
  templateUrl: './product-labels.component.html',
  styleUrls: ['./product-labels.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    NgTemplateOutlet,
    IconComponent,
    ProductBundleValidToLabelComponent,
    ProductBundleMaxOrderCountLabelComponent,
    LuxonDatePipe,
    MatTooltip,
  ],
})
export class ProductLabelsComponent {
  public product: InputSignal<ProductBaseModel> = input.required();
  public groups: InputSignal<ProductLabelGroup[]> = input([] as ProductLabelGroup[]);

  public labels: Signal<ProductLabelModel[] | undefined> = computed(() =>
    this.groups().length
      ? this.product().labels?.filter(x => this.groups().includes(x.group))
      : this.product().labels,
  );

  public prices: Signal<ProductPricesModel | undefined> = computed(() => this.product().prices);
  public displayVertically: InputSignal<boolean> = input(false);
  public iconLabelsBig: InputSignal<boolean> = input(false);
  public hasContent: Signal<boolean> = computed(
    () =>
      Boolean(this.labels()?.length)
      || ['price-best', 'price-discount'].includes(String(this.prices()?.priceType)),
  );
}
